<template>
  <el-dialog :visible.sync="visible" width="520px" :append-to-body="true">
    <div slot="title">
      {{
        editRow.type === 'add'
          ? $t('dashboard-bi::board-management::新增菜单')
          : $t('dashboard-bi::board-management::编辑菜单')
      }}
    </div>
    <el-radio-group v-model="type" :disabled="editRow.type === 'edit'" class="form-type" @change="changeType">
      <el-radio :label="1">{{ $t('dashboard-bi::board-management::菜单') }}</el-radio>
      <el-radio :label="2">{{ $t('dashboard-bi::board-management::目录') }}</el-radio>
    </el-radio-group>
    <el-form :label-position="'right'" :label-width="'110px'" ref="menuform" :model="form" :rules="rules">
      <template v-if="type === 1">
        <el-form-item :label="$t('dashboard-bi::board-management::目录')" prop="parentId">
          <el-select
            v-model="form.parentId"
            :no-data-text="$t('dashboard-bi::board-management::请先创建目录')"
            style="width:100%"
            :disabled="!!form.sourceId"
          >
            <div slot="empty" style="text-align:center;line-height:60px;color:#999;">
              {{ $t('dashboard-bi::board-management::请先') }}
              <el-button type="text" @click="changeType(2)">
                {{ $t('dashboard-bi::board-management::创建目录') }}
              </el-button>
            </div>
            <el-option
              v-for="item in directoryList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::菜单名称')" prop="folderName">
          <el-input v-model="form.folderName" :disabled="!!form.sourceId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::菜单类型')" prop="openType">
          <el-select v-model="form.openType" style="width:100%" :disabled="editRow.type === 'edit'">
            <el-option
              v-for="item in openTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.openType === 1 || (form.openType === 2 && sourceMerchantId)">
          <el-form-item :label="$t('dashboard-bi::board-management::pc')" prop="openData">
            <el-input v-model="form.openData"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              {{ $t('dashboard-bi::board-management::mobile') }}
              <el-tooltip :content="$t('dashboard-bi::board-management::mobile_input_tip')" placement="bottom">
                <i class="iconInfo-Solid iconfont tip-icon"></i>
              </el-tooltip>
            </span>
            <el-input v-model="form.moveUrl"></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="$t('dashboard-bi::board-management::平台看板')" prop="boardID" v-if="form.openType === 2 && !sourceMerchantId">
          <el-select v-model="form.boardID" style="width:100%" :disabled="editRow.type === 'edit'">
            <el-option
              v-for="item in boardList"
              :label="item.folderName"
              :value="item.boardID"
              :key="item.boardID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::显示排序')" prop="position">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::打开方式')" prop="openTarget">
          <el-select v-model="form.openTarget" style="width:100%">
            <el-option :value="1" :label="$t('dashboard-bi::board-management::页签')"></el-option>
            <el-option :value="2" :label="$t('dashboard-bi::board-management::新窗口')"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item :label="$t('dashboard-bi::board-management::目录名称')" prop="folderName">
          <el-input v-model="form.folderName" :disabled="!!form.sourceId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::显示排序')" prop="position">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dashboard-bi::board-management::选择图标')" prop="icon">
          <el-input v-model="form.icon" disabled>
            <i
              slot="suffix"
              class="el-input__icon el-icon-picture"
              style="cursor:pointer"
              v-if="!form.sourceId"
              @click="showSelectIcon = !showSelectIcon"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item v-if="showSelectIcon && !form.sourceId">
          <div class="icon-list">
            <i v-for="item in iconList" :class="iconMapping(item)" class="iconfont" :key="item" @click="form.icon = item"></i>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('system::common::btn::save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addOrUpdateMenu, getDefaultBoard, getMenuList } from '@/server/dashboard.js'
import { iconList, iconMapping } from '@/views/dashboard/board-management/compoents/icon'
export default {
  props: {
    value: {},
    editRow: {
      type: Object,
      default: () => {
        return { type: 'add' }
      }
    },
    // directoryList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    routerType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      type: 1, // 1->菜单， 2-> 目录
      openTypeList: [
        { label: this.$t('dashboard-bi::board-management::第三方链接'), value: 1 },
        { label: this.$t('dashboard-bi::board-management::平台看板'), value: 2 },
        { label: this.$t('dashboard-bi::board-management::空白看板'), value: 3 }
      ],
      boardList: [],
      directoryList: [],
      form: {
        parentId: '',
        folderName: '',
        openType: '',
        openData: '',
        moveUrl: '',
        openTarget: '',
        boardID: '',
        position: '',
        icon: ''
      },
      showSelectIcon: true,
      iconList
    }
  },
  computed: {
    rules() {
      if (this.type === 1) {
        return {
          parentId: [
            { required: true, message: this.$t('dashboard-bi::board-management::请选择目录'), trigger: 'change' }
          ],
          folderName: [
            { required: true, message: this.$t('dashboard-bi::board-management::请输入菜单名称'), trigger: 'blur' }
          ],
          openType: [
            { required: true, message: this.$t('dashboard-bi::board-management::请选择菜单类型'), trigger: 'change' }
          ],
          openData: [
            { required: true, message: this.$t('dashboard-bi::board-management::请输入URL'), trigger: 'blur' }
          ],
          moveUrl: [{ required: true, message: this.$t('dashboard-bi::board-management::请输入URL'), trigger: 'blur' }],
          boardID: [
            { required: true, message: this.$t('dashboard-bi::board-management::请选择平台看板'), trigger: 'change' }
          ],
          openTarget: [
            { required: true, message: this.$t('dashboard-bi::board-management::请选择打开方式'), trigger: 'change' }
          ],
          position: [
            { required: true, message: this.$t('dashboard-bi::board-management::请填写排序'), trigger: 'blur' }
          ]
        }
      } else {
        return {
          folderName: [
            { required: true, message: this.$t('dashboard-bi::board-management::请输入目录名称'), trigger: 'blur' }
          ],
          position: [
            { required: true, message: this.$t('dashboard-bi::board-management::请填写排序'), trigger: 'blur' }
          ],
          icon: [{ required: true, message: this.$t('dashboard-bi::board-management::请选择图标'), trigger: 'blur' }]
        }
      }
    },
    isOwnMerchant() {
      return this.$store.getters.getIsOwnMerchant
    },
    sourceMerchantId() {
      const sourceMerchantIds =
        (this.$store.state.user.hasBindData && this.$store.state.user.hasBindData.sourceMerchantIds) || []
      const merchantId = this.$store.state.user.merchantId
      return sourceMerchantIds.includes(merchantId)
    }
  },
  watch: {
    visible(val) {
      this.$emit('input', val)
    },
    value(val) {
      if (val) {
        this.getDictList()
        this.getDefaultBoard()
        if (this.editRow.type === 'edit') {
          const row = { ...this.editRow.row }
          this.type = row.parentId ? 1 : 2
          this.form = { ...this.form, ...row }
        } else {
          this.form = {
            parentId: '',
            folderName: '',
            openType: '',
            openData: '',
            moveUrl: '',
            openTarget: '',
            boardID: '',
            position: '',
            icon: ''
          }
          this.type = 1
        }
        this.$nextTick(() => {
          this.$refs.menuform.clearValidate()
        })
      }
      this.visible = val
    }
  },
  mounted() {},
  methods: {
    iconMapping,
    async getDictList() {
      const res = await getMenuList({ type: this.routerType, pageNum: 1, pageSize: 10000 })
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.directoryList = data.data.items.map(el => {
          return {
            label: el.folderName,
            value: el.folderID
          }
        })
      }
    },
    async getDefaultBoard() {
      const res = await getDefaultBoard(this.routerType)
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.boardList = data.data
      }
    },
    changeType(type) {
      type && (this.type = type)
      this.$nextTick(() => {
        this.form = {
          parentId: '',
          folderName: '',
          openType: '',
          openData: '',
          moveUrl: '',
          openTarget: '',
          boardID: '',
          position: '',
          icon: ''
        }
        this.$refs.menuform.clearValidate()
      })
    },
    submit() {
      this.$refs.menuform.validate(valid => {
        if (valid) {
          let params = {
            type: this.routerType
          }
          if (this.editRow.type === 'edit') {
            params = { ...params, folderID: this.form.folderID }
            if (this.form.sourceId) {
              params = { ...params, sourceId: this.form.sourceId }
            }
          }
          if (this.type === 1) {
            params = {
              ...params,
              parentId: this.form.parentId,
              folderName: this.form.folderName,
              position: this.form.position,
              openTarget: this.form.openTarget,
              openType: this.form.openType
            }
            switch (params.openType) {
              case 1:
                params = { ...params, openData: this.form.openData, moveUrl: this.form.moveUrl }
                break
              case 2:
                if (this.sourceMerchantId) {
                  params = { ...params, openData: this.form.openData, moveUrl: this.form.moveUrl }
                } else {
                  params = { ...params, boardID: this.form.boardID }
                  for (let i = 0; i < this.boardList.length; i++) {
                    if (this.form.boardID === this.boardList[i].boardID && this.boardList[i].openData) {
                      params = { ...params, openData: this.boardList[i].openData }
                      break
                    }
                  }
                }
                break
            }
          } else {
            params = {
              ...params,
              parentId: 0,
              folderName: this.form.folderName,
              position: this.form.position,
              icon: this.form.icon
            }
          }
          this.addOrUpdateMenu(params)
        }
      })
    },
    async addOrUpdateMenu(params) {
      const res = await addOrUpdateMenu(params)
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.visible = false
        this.$emit('refresh')
        this.$store.dispatch('getBoardList', this.editRow.type === 'edit' ? this.editRow.row : {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-icon {
  color: #999;
}
.form-type {
  padding: 16px;
  background: #f9f9f9;
  width: calc(100% - 32px);
  border-radius: 6px;
  margin-bottom: 24px;
}
.icon-list {
  max-height: 120px;
  overflow: auto;
  background: #f9f9f9;
  padding-top: 24px;
  padding-right: 24px;
  display: flex;
  flex-wrap: wrap;
  .iconfont {
    margin-bottom: 24px;
    margin-left: 24px;
    cursor: pointer;
    font-size: 19px;
  }
}
</style>
